import type { SiteConfig } from '@/types'

export const siteConfig: SiteConfig = {
    name: 'Modulify Site',
    description: 'Describe what you want. AI builds it live.',
    url: 'https://modulify.com'
}